import React, { useState,useEffect } from 'react';
import { toast } from 'react-toastify';
import {format } from 'date-fns';
import { getDefaultReviewList,getSingleReviewTemplateDetail,searchBbbReview } from "../../../../utils/reviewApi";
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import RatingStars from "../../../../components/RatingStars";

const BadgeWidget = ({selectedLayout,isTemplateId, widgetId,reviewTabData,searchedKeyword}) => {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [expandedReviewId, setExpandedReviewId] = useState(null);

  // Default values for the reviewTabData
  const {
      is_website_frontend,
      business_name,
      style_background_color,
      header_is_widget_title,
      header_title,
      header_caption,
      setting_rating_format,
      style_widget_title_color,
      style_widget_title_fonts_title_size,
      style_widget_title_caption_color,
      style_widget_title_fonts_caption_size,
      style_header_background_color,
      header_is_show_header,
      header_write_reviews_button,
      header_source_icon,
      header_rating,
      header_number_of_reviews,
      style_header_text_color,
      style_header_write_review_background_color,
      style_header_write_review_text_color,
      header_write_review_button_type,
      style_rating_stars_color,
      style_load_more_button_color,
      style_load_more_button_text_color,
  } = reviewTabData || {};

  //Handle when clicking "Read More"
  const handleReadMoreClick = (review) => {
    setExpandedReviewId(prev =>
      prev === review.id ? null : review.id
    );
  };

  //Handle Main Popup
  const togglePopup = () => {
      setShowPopup(!showPopup);
  };

  // Load More function
  const handleLoadMore = () => {
      setVisibleCount((prevCount) => prevCount + 5);
  };

  // Fetching Review data
  useEffect(() => {
      const fetchData = async () => {
          setLoading(true);
          try {
              let result;
              if (isTemplateId) {
                  result = await getSingleReviewTemplateDetail(isTemplateId);
              } else if (widgetId) {
                  result = await getSingleWidgetDetail(widgetId);
              } else if (business_name) {
                const payload = { business_name: business_name };
                result = await searchBbbReview(payload);
              } else {
                  let app_type = 'Bbb_Review';
                  result = await getDefaultReviewList(app_type);
              }
              setApiData(result);
          } catch (error) {
              toast.warning(error.message);
          } finally {
              setLoading(false); 
          }
      };

      fetchData();
  }, [isTemplateId, widgetId, business_name]);
  return (
   <>
    <div className={`upgadeify-review-template-widget upgadeify-badge-style ${showPopup ? 'main-popup-open' : ''} ${is_website_frontend}`}>
        {/* Loader and No Api Data Handling */}
        {loading ? (
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Loading please wait...</p>
            </div>
        ) : apiData?.status === true ? (
        <>
          <div className='upgadeify-badge-style-header' onClick={togglePopup}>
            <div className='upgadeify-badge-header-title'>
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><circle cx="12" cy="12.5" r="10" fill="#005A78"></circle><path fill="#fff" fill-rule="evenodd" d="M15.586 17.278h-7.32L8 18.212h1.95l.373 1.288h3.207l.371-1.288h1.951l-.266-.934ZM9.46 12.03c-.27.397-.38.891-.308 1.375.073.484.322.917.693 1.205l1.752 1.358a.487.487 0 0 1 .096.647l.264.204.926-1.366a1.919 1.919 0 0 0 .308-1.375 1.858 1.858 0 0 0-.695-1.203l-1.751-1.358a.464.464 0 0 1-.18-.376c0-.097.029-.191.083-.27l-.264-.204-.924 1.363Zm1.056-5.462a2.783 2.783 0 0 0-.447 1.995c.104.702.466 1.33 1.006 1.746l2.202 1.702c.29.223.484.56.54.936a1.49 1.49 0 0 1-.242 1.068l.212.166 1.735-2.56c.39-.575.551-1.292.447-1.994a2.71 2.71 0 0 0-1.006-1.747l-2.658-2.063a.863.863 0 0 1-.171-1.154L11.92 4.5l-1.405 2.068Z" clip-rule="evenodd"></path></svg>

              <div className='upgadeify-badge-reviews-header-title-text'>BBB Rating</div>
            </div>
            <div className='upgadeify-bbb-reviews-header-rating'>
              <div className="upgadeify-bbb-reviews-header-rating-text">{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
              <div className="upgadeify-bbb-reviews-item-rating">
                <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
              </div>
            </div>
            <div className="upgadeify-badge-reviews-readmore">
              Read our { apiData.data.total_reviews }  reviews
            </div>
          </div>
        </>
          ) : (
              <div className="no-inner-result-found">
                  <p>No BBB reviews found please check the url.</p>
              </div>
          )}
        </div>
    
        {showPopup && (
        <div className="upgadeify-badge-fixed-style">
          <div className="upgadeify-badge-style-inner" style={{backgroundColor: style_background_color}}>
              <button className="upgadeify-badge-fixed-style-close" onClick={togglePopup}>X</button>
              {Number(header_is_widget_title) === 1 && (
                <>
                  <div className="upgadeify-badge-fixed-style-title">
                      <h2 style={{ color: style_widget_title_color,fontSize: style_widget_title_fonts_title_size }}>{header_title || ""}</h2>
                      <h2 style={{ color: style_widget_title_caption_color,fontSize: style_widget_title_fonts_caption_size }}>{header_caption || ""}</h2>
                  </div>
                </>
              )}
              {Number(header_is_show_header) === 1 &&
                (Number(header_source_icon) === 1 ||
                    Number(header_rating) === 1 ||
                    Number(header_number_of_reviews) === 1 ||
                    Number(header_write_reviews_button) === 1) && (
               <div className="upgadeify-badge-fixed-style-header" style={{ backgroundColor: style_header_background_color,}}>
                    <div className='upgadeify-bbb-reviews-header-left'>
                      {Number(header_source_icon) === 1 && (
                        <div className='upgadeify-bbb-reviews-header-title'>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 63 36" className="injected-svg"><path fill="#005A78" fill-rule="evenodd" d="m12.63 23.445.442 1.494H9.825L9.207 27h-5.34l-.62-2.061H0l.443-1.494H12.63ZM28.769 9.437c1.719 0 3.066.485 3.93 1.365a3.579 3.579 0 0 1 1.03 2.62v.036c0 1.74-.901 2.708-1.984 3.327 1.74.684 2.814 1.718 2.814 3.788v.045c0 2.817-2.233 4.226-5.628 4.226h-7.144V9.436h6.982Zm14.219 0c1.72 0 3.067.485 3.93 1.365a3.583 3.583 0 0 1 1.027 2.62v.036c0 1.74-.902 2.708-1.984 3.327 1.74.684 2.814 1.718 2.814 3.788v.045c0 2.817-2.233 4.226-5.628 4.226h-7.14V9.436h6.98Zm14.221 0c1.72 0 3.067.485 3.931 1.365a3.58 3.58 0 0 1 1.03 2.62v.036c0 1.74-.902 2.708-1.984 3.327 1.74.684 2.814 1.718 2.814 3.788v.045c0 2.817-2.235 4.226-5.629 4.226h-7.144V9.436h6.982Zm-53.24 3.43.439.327a.742.742 0 0 0-.128.55.74.74 0 0 0 .29.483L7.485 16.4a2.95 2.95 0 0 1 1.157 1.924 2.988 2.988 0 0 1-.513 2.2L6.587 22.71l-.439-.326a.756.756 0 0 0-.16-1.035l-2.917-2.174a2.966 2.966 0 0 1-1.154-1.927 3.014 3.014 0 0 1 .513-2.2l1.539-2.18Zm24.866 5.636H25.01v3.388l3.93-.016c1.462 0 2.346-.529 2.346-1.664v-.044c0-1.036-.752-1.664-2.45-1.664Zm14.221 0H39.23v3.388l3.93-.016c1.46 0 2.345-.529 2.345-1.664v-.044c0-1.036-.753-1.664-2.449-1.664Zm14.22 0H53.45v3.388l3.93-.016c1.46 0 2.345-.529 2.345-1.664v-.044c0-1.036-.753-1.664-2.45-1.664ZM6.528 3l.354.261c-.418.59-.29 1.417.284 1.846l4.427 3.301a4.302 4.302 0 0 1 1.674 2.795 4.37 4.37 0 0 1-.744 3.191L9.634 18.49l-.354-.265a2.32 2.32 0 0 0 .403-1.71 2.292 2.292 0 0 0-.897-1.498L5.12 12.294A4.277 4.277 0 0 1 3.445 9.5a4.33 4.33 0 0 1 .744-3.19L6.528 3Zm21.752 9.41h-3.271v3.257h3.05c1.462 0 2.385-.484 2.385-1.628v-.045c0-1.013-.773-1.584-2.164-1.584Zm14.219 0H39.23v3.257h3.049c1.461 0 2.385-.484 2.385-1.628v-.045c0-1.013-.774-1.584-2.165-1.584Zm14.221 0h-3.265v3.257H56.5c1.461 0 2.385-.484 2.385-1.628v-.045c0-1.013-.774-1.584-2.165-1.584Z" clip-rule="evenodd"></path></svg>
                              <div className='upgadeify-bbb-reviews-header-title-text' style={{color: style_header_text_color,}}>Reviews</div>
                        </div>
                        )}
                        <div className='upgadeify-bbb-reviews-header-rating'>
                          {Number(header_rating) === 1 && (
                          <>
                              <div className="upgadeify-bbb-reviews-header-rating-text" style={{color: style_header_text_color,}}>{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
                              <div className="upgadeify-bbb-reviews-item-rating">
                                  <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
                              </div>
                          </>
                          )}
                          {Number(header_number_of_reviews) === 1 && (
                              <span className="upgadeify-bbb-reviews-header-number-of-reviews-text">({apiData.data.total_reviews})</span>
                          )}
                        </div>
                    </div>
                    {Number(header_write_reviews_button) === 1 && (
                        <div className='upgadeify-alieyelpxpress-reviews-header-right'>
                            <a
                                href={apiData?.data?.google_url?.startsWith('http') ? apiData.data.google_url : `https://${apiData.data.google_url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className='upgadeify-bbb-reviews-header-button'
                                style={{color: style_header_write_review_text_color,backgroundColor: style_header_write_review_background_color,fontSize: header_write_review_button_type}}>Review us on BBB
                            </a>
                        </div>
                    )}
                </div>
              )}
              {/* Reviews List */}
              {apiData.data.review_list.slice(0, visibleCount).map((review) => (
                  <ReviewLoopItem key={review.id} review={review} handleReadMoreClick={handleReadMoreClick} reviewTabData={reviewTabData} expandedReviewId={expandedReviewId}/>
              ))}
              {/* Load More Button  */}
              {visibleCount < apiData.data.review_list.length && (
                <div className="load-more-button">
                    <button onClick={handleLoadMore} style={{backgroundColor: style_load_more_button_color,color: style_load_more_button_text_color}}>Load More</button>
                </div>
              )}
          </div>
        </div>
      )}
   </>
  );
};

const ReviewLoopItem = ({ review, handleReadMoreClick, reviewTabData, expandedReviewId }) => (
    <>
        <div className="upgadeify-bbb-reviews">
            <div className='upgadeify-bbb-reviews-item' style={{ padding: `${reviewTabData.layout_item_spacing}px`, backgroundColor: reviewTabData.style_review_background_color,}}>
               <div className='upgadeify-bbb-reviews-head'>
                {Number(reviewTabData.review_is_show_reviewer_picture) === 1 && (
                    <div className="upgadeify-bbb-reviews-item-image">
                        {review.image ? (
                            <img src={review.image} alt="Review" />
                        ) : (
                            <div className="fallback-avatar">
                                {review.name.charAt(0)}
                            </div>
                        )}

                       
                    </div>
                )}
                <div className='upgadeify-bbb-reviews-item-name'>
                    {Number(reviewTabData.review_is_show_reviewer_name) === 1 && (
                        Number(reviewTabData.setting_is_enable_external_links) === 1 && review.author_url ? ( 
                            <a
                                href={review.author_url} 
                                target={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "_blank" : "_self"}
                                rel={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "noopener noreferrer" : undefined}
                                style={{ color: reviewTabData.style_review_reviewer_name_color }}
                            >
                                <span className="upgadeify-bbb-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>{review.name}</span>
                            </a>
                        ) : (
                            <span className="upgadeify-bbb-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>
                                {review.name}
                            </span>
                        )
                    )}

                    {Number(reviewTabData.review_is_show_verified_badge) === 1 && (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" className="review-verified-badge-icon" aria-hidden="true">
                            <path fill={reviewTabData.style_review_verified_badge_color} d="M6.757.236a.35.35 0 0 1 .486 0l1.106 1.07a.35.35 0 0 0 .329.089l1.493-.375a.35.35 0 0 1 .422.244l.422 1.48a.35.35 0 0 0 .24.24l1.481.423a.35.35 0 0 1 .244.422l-.375 1.493a.35.35 0 0 0 .088.329l1.071 1.106a.35.35 0 0 1 0 .486l-1.07 1.106a.35.35 0 0 0-.089.329l.375 1.493a.35.35 0 0 1-.244.422l-1.48.422a.35.35 0 0 0-.24.24l-.423 1.481a.35.35 0 0 1-.422.244l-1.493-.375a.35.35 0 0 0-.329.088l-1.106 1.071a.35.35 0 0 1-.486 0l-1.106-1.07a.35.35 0 0 0-.329-.089l-1.493.375a.35.35 0 0 1-.422-.244l-.422-1.48a.35.35 0 0 0-.24-.24l-1.481-.423a.35.35 0 0 1-.244-.422l.375-1.493a.35.35 0 0 0-.088-.329L.236 7.243a.35.35 0 0 1 0-.486l1.07-1.106a.35.35 0 0 0 .089-.329L1.02 3.829a.35.35 0 0 1 .244-.422l1.48-.422a.35.35 0 0 0 .24-.24l.423-1.481a.35.35 0 0 1 .422-.244l1.493.375a.35.35 0 0 0 .329-.088L6.757.236Z"></path><path fill="#fff" fill-rule="evenodd" d="M9.065 4.85a.644.644 0 0 1 .899 0 .615.615 0 0 1 .053.823l-.053.059L6.48 9.15a.645.645 0 0 1-.84.052l-.06-.052-1.66-1.527a.616.616 0 0 1 0-.882.645.645 0 0 1 .84-.052l.06.052 1.21 1.086 3.034-2.978Z" clip-rule="evenodd"></path>
                        </svg>
                    )}

                    <span className="upgadeify-bbb-reviews-item-date"> 
                        {Number(reviewTabData.review_is_show_date) === 1 && (
                            <span style={{color: reviewTabData.style_review_date_color,}}>{review.review_date ? format(new Date(review.review_date), 'yyyy-MM-dd') : ''}</span>
                        )}
                    </span>
                </div>
               </div>
                <div className="upgadeify-bbb-reviews-item-content">
                    {Number(reviewTabData.review_is_show_rating) === 1 && (
                        <span className="upgadeify-bbb-reviews-item-rating" style={{ fontSize: reviewTabData.style_review_rating_size }}>
                            <RatingStars average_rating={review.rating} newColor={reviewTabData.style_rating_stars_color}/>
                        </span>
                    )}
                    <div className="upgadeify-bbb-reviews-item-text" style={{color: `${reviewTabData.style_review_text_color}`,fontSize: reviewTabData.style_review_text_font_size}}>
                        {expandedReviewId === review.id ? review.description: review.description.length > 50
                            ? `${review.description.slice(0, 50)}...`
                            : review.description
                        }
                    </div>
                    {review.description.length > 50 && (
                      <div className="upgadeify-bbb-reviews-readmore" onClick={() => handleReadMoreClick(review)}
                        style={{
                          color: reviewTabData.style_read_more_color,
                          fontSize: reviewTabData.style_review_text_font_size
                        }}
                      >
                        {expandedReviewId === review.id ? 'Read less' : 'Read more'}
                      </div>
                    )}
                    {Number(reviewTabData.review_is_show_review_source) === 1 && (  
                        <div className='upgadeify-bbb-reviews-item-image-badge'>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><circle cx="12" cy="12.5" r="10" fill="#005A78"></circle><path fill="#fff" fill-rule="evenodd" d="M15.586 17.278h-7.32L8 18.212h1.95l.373 1.288h3.207l.371-1.288h1.951l-.266-.934ZM9.46 12.03c-.27.397-.38.891-.308 1.375.073.484.322.917.693 1.205l1.752 1.358a.487.487 0 0 1 .096.647l.264.204.926-1.366a1.919 1.919 0 0 0 .308-1.375 1.858 1.858 0 0 0-.695-1.203l-1.751-1.358a.464.464 0 0 1-.18-.376c0-.097.029-.191.083-.27l-.264-.204-.924 1.363Zm1.056-5.462a2.783 2.783 0 0 0-.447 1.995c.104.702.466 1.33 1.006 1.746l2.202 1.702c.29.223.484.56.54.936a1.49 1.49 0 0 1-.242 1.068l.212.166 1.735-2.56c.39-.575.551-1.292.447-1.994a2.71 2.71 0 0 0-1.006-1.747l-2.658-2.063a.863.863 0 0 1-.171-1.154L11.92 4.5l-1.405 2.068Z" clip-rule="evenodd"></path></svg>
                            Posted On   
                            <> <a href={`https://www.bbb.com`} target="blank">BBB</a></> 
                        </div> 
                    )} 
                </div>
            </div>
        </div>
    </>
);

export default BadgeWidget;
